import { useState, useMemo } from "react";
import {
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
    Button,
    Typography,
} from "@material-tailwind/react";
import MaterialIcon from "components/material-icon";
import FormikCheckbox from "components/form/formik-checkbox";
import EditThemeDialog from "./edit-theme";
import { sortThemesByName } from "../utils/sort-themes";
import { updateThemeName } from "../utils/update-theme-name";
import { toast } from "react-toastify";
import { GobbyTable, GobbyTableHead, GobbyTableBody, GobbyTableRow, GobbyTableHeader, GobbyTableCell } from "components/ui/gobby-table";

export default function ResponseThemesDialog({
    open,
    onClose,
    themes = [], // [{ id, name }]
    surveyId,
    themesDataMutate,
    customResponsesFilterMutate,
}) {
    const handleClose = () => {
        onClose();
    };
    const [selectedThemes, setSelectedThemes] = useState([]);
    const [showEditThemeDialog, setShowEditThemeDialog] = useState(false);
    const [editingTheme, setEditingTheme] = useState(null);

    const sortedThemes = useMemo(() => sortThemesByName(themes), [themes]);

    const toggleThemeSelection = (id) => {
        setSelectedThemes((prev) =>
            prev.includes(id) ? prev.filter((t) => t !== id) : [...prev, id],
        );
    };

    const handleEditThemeName = async (id, newName) => {
        const { ok } = await updateThemeName({ surveyId, themeId: id, name: newName });
        if (ok) {
            themesDataMutate();
            customResponsesFilterMutate();
            toast.success("Theme Edited");
        }
        setSelectedThemes([]);
    };

    return (
        <>
            {/* ResponseThemesDialog */}
            <Dialog
                open={open && !showEditThemeDialog}
                handler={handleClose}
                className="dialog"
            >
                <DialogHeader className="dialog__header ">
                    <Typography variant="h4">List Themes</Typography>
                </DialogHeader>
                <DialogBody className="dialog__body">
                    {!(sortedThemes?.length > 0) && (
                        <Typography className=" text-center">
                            Response has not been allocated to any theme yet
                        </Typography>
                    )}
                    {/* Scrollable List of Themes */}
                    <GobbyTable>
                        <GobbyTableBody>
                            {!!sortedThemes &&
                                sortedThemes?.map((theme, index) => (
                                    <GobbyTableRow key={theme.id}>
                                        <GobbyTableCell>
                                            <Typography variant="paragraph">
                                                {theme.name}
                                            </Typography>
                                        </GobbyTableCell>
                                        <GobbyTableCell className="flex justify-end">
                                            <Button
                                                type="button"
                                                className="btn-icon--secondary"
                                                onClick={() => {
                                                    setEditingTheme(theme);
                                                    setShowEditThemeDialog(
                                                        true,
                                                    );
                                                }}
                                            >
                                                <MaterialIcon name="edit" />
                                            </Button>
                                        </GobbyTableCell>
                                    </GobbyTableRow>
                                ))}
                        </GobbyTableBody>
                    </GobbyTable>
                </DialogBody>
            </Dialog>

            {/* Edit Theme Dialog */}
            {editingTheme && (
                <EditThemeDialog
                    open={showEditThemeDialog}
                    theme={editingTheme}
                    onClose={() => setShowEditThemeDialog(false)}
                    onSaveThemeName={(id, newName) => {
                        handleEditThemeName(id, newName);
                        setShowEditThemeDialog(false);
                    }}
                />
            )}
        </>
    );
}
